export enum BeachType {
  SandBeach = 'sandBeach',
  PebbleBeach = 'pebbleBeach',
  SandPebbleBeach = 'sandPebbleBeach',
}

export enum ChildService {
  Animators = 'children_animators',
  Pool = 'children_pool',
  Menu = 'children_childmenu',
  Playroom = 'children_playroom',
  Clubs = 'children_clubs',
  Bed = 'children_childBed',
  Nanny = 'children_nanny',
  SeaEntry = 'children_seaEnter',
}

export enum RestType {
  Beach = 'restBeach',
  City = 'restCity',
  Mountain = 'restMountainSki',
  Wellness = 'restWellness',
  Eco = 'restEco',
}

export enum RenovationType {
  RecentlyOpened = 'recently_opened',
  FreshRenovation = 'fresh_renovation',
}

export enum DistanceLift {
  SkiIn = 'rightEntrance',
  Walking = 'walkingDistance',
  Bus = 'busDistance',
}

export enum HotelFeature {
  AirConditioner = 'air_conditioner',
  Wifi = 'wifi',
  NearTheBeach = 'near_the_beach',
  NearTheLift = 'near_the_lift',
  NearTheCenter = 'near_the_center',
  WithKids = 'with_kids',
  ForCouples = 'for_couples',
  AdultsOnly = 'adults_only',
  Wellness = 'wellness',
}
/**
 * Удобства отеля — группа фильтра «Удобства».
 *
 * Пересекается с `HotelFeature` по названиям, но это другой набор: у удобств свои предикаты
 * (`AdultsOnly` и `WithKids` здесь НЕ гасят друг друга, а `WithKids` не считает «счётные» детские сервисы),
 * поэтому признаки считаются отдельно, как в десктопной выдаче.
 */
export enum HotelFacility {
  LonelyMan = 'lonelyMan',
  AirConditioner = 'airConditioner',
  Wifi = 'wifi',
  SpaAndHealth = 'spaAndHealth',
  BayLocated = 'bayLocated',
  AdultsOnly = 'adultsOnly',
  WithKids = 'withKids',
  ForCouples = 'forCouples',
  WithAnimals = 'withAnimals',
  Parking = 'parking',
  SaunaBathHammam = 'saunaBathHammam',
  Jacuzzi = 'jacuzzi',
}

/** Водные развлечения отеля — группа фильтра «Водные развлечения». */
export enum WaterActivity {
  OpenPool = 'openPool',
  IndoorPool = 'closePool',
  HeatedPool = 'heatedPool',
  Aquapark = 'aquapark',
  SeaWaterPool = 'seaPool',
  WaterSlides = 'waterslides',
}

/** Линия пляжа: расстояние до моря считает поиск, фронт получает готовый номер линии. */
export enum BeachLine {
  First = 'firstLine',
  Second = 'secondLine',
  Third = 'thirdLine',
}
